<h2 class="popup-heading m-0" mat-dialog-title>
  {{subscriptionPlan === 'hobbyist' ? 'Hobbyist' : subscriptionPlan}} Cancel Subscription
</h2>

<div class="content">
  <p>
    Are you sure you want to cancel your subscription? Please note that we will not refund your current
    subscription which is valid until <strong>{{ subscription_end_date }}</strong>, 
    but it will not auto-renew at this time.
  </p>
</div>

<div class="action-buttons" align="end" style="padding: 10px;">
  <button class="cancel-popup" mat-stroked-button (click)="close()">Cancel</button>
  <button class="save" mat-flat-button (click)="Confirm()"
    [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}">
    <mat-icon *ngIf="processing">
      <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
    </mat-icon>
    Confirm
  </button>
</div>
